var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "top-bar drag" },
    [
      _c(
        "v-layout",
        { attrs: { row: "", "justify-space-between": "", "align-center": "" } },
        [
          _c(
            "v-flex",
            { attrs: { shrink: "" } },
            [
              _vm._t("default", function() {
                return [_c("div", { staticStyle: { width: "28px" } })]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c("v-flex", { staticClass: "top-bar-title" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { shrink: "" } },
            [
              _vm.isMultiSelect
                ? _c("window-header-button", {
                    attrs: { action: "newtab" },
                    on: { onClick: _vm.openTab }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("window-header-button", {
                on: {
                  onClick: function($event) {
                    return _vm.$emit("close")
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3af8dc32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3af8dc32","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_Molecules/FormHeader.vue
// module id = null
// module chunks = 